import {motion} from 'framer-motion';

export const AnimatedSeal = ({
    text,
    className,
    color = 'red',
}: {
    text: string;
    color?: 'red' | 'green' | 'blue' | 'yellow' | 'purple';
    textClassName?: string;
    className: string;
}) => {
    return (
        <div className={`${className}`}>
            <motion.div
                style={{borderWidth: '10px'}}
                className={`relative flex items-center justify-center w-72 h-36 border-${color}-600 rounded-lg backdrop-blur-sm`}
                initial={{scale: 1.3}}
                animate={{scale: 1}}
                transition={{duration: 0.2, ease: 'easeOut'}}>
                <span className={`text-${color}-600 text-5xl font-bold`}>
                    {text}
                </span>
            </motion.div>
        </div>
    );
};
